@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

<p-dialog header="Default Booking Fee Already Set" [(visible)]="showDefaultWarning" [style]="{width: '480px'}" [modal]="true" [baseZIndex]="10000" [closable]="false">
  <div style="display:flex; align-items:flex-start; gap:16px; padding: 8px 0 16px;">
    <span class="pi pi-exclamation-triangle" style="color:#f59e0b; font-size:2rem; flex-shrink:0; margin-top:2px;"></span>
    <div>
      <p style="margin:0 0 8px; font-size:1rem;">There is already a default Booking Fee set:</p>
      <p style="margin:0 0 12px; font-weight:600; font-size:1rem;">{{existingDefaultName}}</p>
      <p style="margin:0; color:#6b7280;">Setting this as default will replace it. Do you want to continue?</p>
    </div>
  </div>
  <ng-template #footer>
    <button pButton pRipple type="button" class="p-button p-element p-button-success" (click)="confirmReplaceDefault()">
      <span class="pi pi-check" style="margin-right:8px;"></span>Yes, replace it
    </button>
    <button pButton pRipple type="button" class="p-button p-element p-button-outlined p-button-secondary" style="margin-left:8px;" (click)="showDefaultWarning = false">
      <span class="pi pi-times" style="margin-right:8px;"></span>Cancel
    </button>
  </ng-template>
</p-dialog>

@if (AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Booking Fee
      </h3></div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Booking Fees can be added onto a customer's purchase to help recover the cost of processing the transaction. The bookng fee is always in addition to the amount of the deposit
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <div class="field mb-4 col-12">
            <label for="feename" class="font-medium">Name</label>
            <input id="feename" [(ngModel)]="BookingFee.name" type="text" pInputText>
          </div>
          <div class="field mb-4 col-12">
            <label class="font-medium">Colour</label>
            <div class="flex align-items-center gap-3">
              <p-colorpicker [(ngModel)]="BookingFee.colour" format="hex"></p-colorpicker>
              <input pInputText [(ngModel)]="BookingFee.colour"
                #feeColourInput="ngModel"
                pattern="^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$"
                placeholder="#RRGGBB"
                class="w-8rem text-sm font-mono"
                [ngClass]="{'ng-invalid ng-dirty': feeColourInput.invalid && feeColourInput.dirty}" />
                @if (feeColourInput.invalid && feeColourInput.dirty) {
                  <small class="p-error">
                    Must be a valid hex colour (e.g. #FF5733)
                  </small>
                }
              </div>
            </div>
            <div class="field mb-4 col-12">
              <label class="font-medium">Default Booking Fee</label>
              <p-selectbutton [(ngModel)]="BookingFee.isdefault" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
            </div>
            <!--<div class="field mb-4 col-12">
            <label for="classname" class="font-medium">Show Public Message</label>
            <p-selectbutton id="selectionmode" [(ngModel)]="BookingFee.bfpublicshowtext" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
          </div>
          <div *ngIf="BookingFee.bfpublicshowtext" class="field mb-4 col-12">
            <label for="classname" class="font-medium">Public Message</label>
            <input  id="classname" [(ngModel)]="BookingFee.bfpublictext" type="text" [ngStyle]="{'border-color': (classNameValid==false) ? '#FF0000':''}" (keyup)="DoValidCheck()" pInputText>
          </div>
          <div *ngIf="!publicTextValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Booking Fee Message.</div> -->
          <div class="field mb-4 col-12">
            <label for="classname" class="font-medium">Apply Public Booking Fee</label>
            <p-selectbutton [(ngModel)]="BookingFee.bfpublicapply" id="selectionmode" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
          </div>
          @if (BookingFee.bfpublicapply) {
            <div>
              <div class="field mb-4 col-12">
                <label for="classname" class="font-medium">Public Booking Fee Type</label>
                <p-selectbutton [(ngModel)]="BookingFee.bfpublictype" [style]="{'width': '400px'}" id="selectionmode" [options]="stateOptionsType"></p-selectbutton>
              </div>
              @if (BookingFee.bfpublictype!='PERCENTAGE') {
                <div class="field mb-4 col-12">
                  <label for="classname" class="font-medium">Public Booking Fee Amount</label><br>
                  <p-inputnumber [(ngModel)]="BookingFee.bfpublicfee" [style]="{'width': '400px'}"  mode="currency" currency={{CurrencySymbol}} [showButtons]="true" max="100" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                </div>
              }
              @if (BookingFee.bfpublictype=='PERCENTAGE') {
                <div class="field mb-4 col-12">
                  <label for="classname" class="font-medium">Public Booking Fee Amount</label><br>
                  <p-inputnumber [(ngModel)]="BookingFee.bfpublicfee" [style]="{'width': '400px'}"  suffix="%" [showButtons]="true" max="100" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                </div>
              }
              @if (BookingFee.bfpublictype!='FIXED') {
                <div>
                  <div class="field mb-4 col-12">
                    <label for="classname" class="font-medium">Public Booking Fee Min</label><br>
                    <p-inputnumber [(ngModel)]="BookingFee.bfpublicmin" [style]="{'width': '400px'}" mode="currency" currency={{CurrencySymbol}} [showButtons]="true" max="9999" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                  </div>
                  <div class="field mb-4 col-12">
                    <label for="classname" class="font-medium">Public Booking Fee Max</label><br>
                    <p-inputnumber [(ngModel)]="BookingFee.bfpublicmax" [style]="{'width': '400px'}" mode="currency" currency={{CurrencySymbol}}  [showButtons]="true" max="9999" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                  </div>
                  @if (!publicMinMaxValid) {
                    <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Your Admin Booking Fee Max must be greater than the Min.</div>
                  }
                </div>
              }
              <div class="field mb-4 col-12">
                <label for="classname" class="font-medium">Booking Fee is applied to Bookings made by Members</label>
                <p-selectbutton [(ngModel)]="BookingFee.bookingfeeappliestomemberspublic" id="selectionmode" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
              </div>
              <div class="field mb-4 col-12">
                <label for="classname" class="font-medium">Booking Fee is applied when purchasing Memberships</label>
                <p-selectbutton [(ngModel)]="BookingFee.bookingfeeappliedonmembershippurchasespublic" id="selectionmode" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
              </div>
            </div>
          }
          <div class="field mb-4 col-12">
            <label for="classname" class="font-medium">Apply Admin Booking Fee</label>
            <p-selectbutton [(ngModel)]="BookingFee.bfadminapply" id="selectionmode" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
          </div>
          @if (BookingFee.bfadminapply) {
            <div>
              <div class="field mb-4 col-12">
                <label for="classname" class="font-medium">Admin Booking Fee Type</label>
                <p-selectbutton [(ngModel)]="BookingFee.bfadmintype" id="selectionmode" [style]="{'width': '400px'}" [options]="stateOptionsType"></p-selectbutton>
              </div>
              @if (BookingFee.bfadmintype!='PERCENTAGE') {
                <div class="field mb-4 col-12">
                  <label for="classname" class="font-medium">Admin Booking Fee Amount</label>
                  <p-inputnumber [(ngModel)]="BookingFee.bfadminfee" [style]="{'width': '400px'}" mode="currency" currency={{CurrencySymbol}} [showButtons]="true" max="9999" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                </div>
              }
              @if (BookingFee.bfadmintype=='PERCENTAGE') {
                <div class="field mb-4 col-12">
                  <label for="classname" class="font-medium">Admin Booking Fee Amount</label>
                  <p-inputnumber [(ngModel)]="BookingFee.bfadminfee" [style]="{'width': '400px'}" suffix="%" [showButtons]="true" max="9999" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                </div>
              }
              @if (BookingFee.bfadmintype!='FIXED') {
                <div>
                  <div class="field mb-4 col-12">
                    <label for="classname" class="font-medium">Admin Booking Fee Min</label>
                    <p-inputnumber [(ngModel)]="BookingFee.bfadminmin" [style]="{'width': '400px'}" mode="currency" currency={{CurrencySymbol}}  [showButtons]="true" max="100" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                  </div>
                  <div class="field mb-4 col-12">
                    <label for="classname" class="font-medium">Admin Booking Fee Max</label>
                    <p-inputnumber  [(ngModel)]="BookingFee.bfadminmax"[style]="{'width': '400px'}" mode="currency" currency={{CurrencySymbol}} [showButtons]="true" max="100" min="0" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
                  </div>
                  @if (!adminMinMaxValid) {
                    <div class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Your Public Booking Fee Max must be greater than the Min.</div>
                  }
                </div>
              }
              <div class="field mb-4 col-12">
                <label for="classname" class="font-medium">Booking Fee is applied to Bookings made by Members</label>
                <p-selectbutton [(ngModel)]="BookingFee.bookingfeeappliestomembersadmin" id="selectionmode" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
              </div>
              <div class="field mb-4 col-12">
                <label for="classname" class="font-medium">Booking Fee is applied when purchasing Memberships</label>
                <p-selectbutton [(ngModel)]="BookingFee.bookingfeeappliedonmembershippurchasesadmin" id="selectionmode" [style]="{'width': '400px'}" [options]="stateOptions"></p-selectbutton>
              </div>
            </div>
          }
          <div class="col-12">
            <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
              <span class="pi pi-pencil" style="margin-right:8px;"></span>
            Save Changes</button>
            &nbsp;
            <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
              <span class="pi pi-times" style="margin-right:8px;"></span>
            Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </div>
}